export const L_REQUEST_AB_USER_ADD_TO_TEST = 'L_REQUEST_AB_USER_ADD_TO_TEST';
export const L_REQUEST_AB_USER_REMOVE_FROM_TEST = 'L_REQUEST_AB_USER_REMOVE_FROM_TEST';
export const L_REQUEST_AB_ADD_TO_TEST = 'L_REQUEST_AB_ADD_TO_TEST';
export const L_REQUEST_AB_REMOVE_FROM_TEST = 'L_REQUEST_AB_REMOVE_FROM_TEST';
export const L_REQUEST_AB_CLEAR = '__ALL__';
